import { TopicDetails, GetTopicFilters, TopicGroup } from 'modules/topics';
import { ApiRequest } from './network';
import { SparrowApi } from 'api/network/adapters/SparrowApi';

export class TagsApi {
    constructor(private _sparrowApi: SparrowApi) {
    }
    
    public searchTopics = (filters?: GetTopicFilters) : ApiRequest<TopicGroup[]> => {
        const body = filters ?? { ascending: true }
        return new ApiRequest(
            this._sparrowApi.TenantRequest()
                .post('/{tenant}/adminapi/v1/topics', body)
        );
    }

    public getTopicById = (id: string): ApiRequest => {
        return new ApiRequest(
            this._sparrowApi.TenantRequest().get(`/{tenant}/adminapi/v1/topics/topic/${id}`)
        );
    }

    public createTopicGroup = (name: string): ApiRequest => {
        const encodedName = encodeURIComponent(name)
        return new ApiRequest(
            this._sparrowApi.TenantRequest()
                .post(`/{tenant}/adminapi/v1/topics/new/group?name=${encodedName}`)
        );
    }

    public createTopic = (input: TopicDetails) => {
        const topic = {
            name: input.name,
            group: input.groupId,
            default: input.default,
            mandatory: input.mandatory,
            restricted: input.restricted,
            defaultFor: input.defaultFor.map(t => t.id),
            mandatoryFor: input.mandatoryFor.map(t => t.id),
            restrictedTo: input.restrictedTo.map(t => t.id)
        }

        return new ApiRequest(
            this._sparrowApi.TenantRequest()
                .post('/{tenant}/adminapi/v1/topics/new', topic)
        );
    }

    public editTopicGroup = (groupId: string, name: string) => {
        const encodedName = encodeURIComponent(name);
        return new ApiRequest(
            this._sparrowApi.TenantRequest()
                .put(`/{tenant}/adminapi/v1/topics/group/${groupId}?name=${encodedName}`)
        );
    }

    public editTopic = (topicId: string, input: TopicDetails) => {
        const body = {
            name: input.name,
            group: input.groupId,
            default: input.default,
            mandatory: input.mandatory,
            restricted: input.restricted,
            defaultFor: input.defaultFor.map(a => a.id),
            mandatoryFor: input.mandatoryFor.map(a => a.id),
            restrictedTo: input.restrictedTo.map(a => a.id),
        }

        return new ApiRequest(
            this._sparrowApi.TenantRequest()
                .put(`/{tenant}/adminapi/v1/topics/topic/${topicId}`, body)
        );
    }

    public editTopicState = (topics: string[], disable: boolean) => {
        return new ApiRequest(
            this._sparrowApi.TenantRequest()
                .put(`/{tenant}/adminapi/v1/topics/state?disable=${disable}`, topics)
        );
    }

    public moveTopics = (topics: string[], groupId: string | null) => {
        return new ApiRequest(
            this._sparrowApi.TenantRequest()
                .put(`/{tenant}/adminapi/v1/topics/move/${groupId}`, topics)
        );
    }

    public deleteTopicsAndGroups = (topics: string[], topicGroups: string[]) => {    
        const body = {
            topics: topics,
            topicGroups: topicGroups
        }
        return new ApiRequest(
            this._sparrowApi.TenantRequest().delete(`/{tenant}/adminapi/v1/topics`, {
                data: {...body}
            })
        );
    }

    public getTopicUsageStatus = (topics: string[]): ApiRequest => {
        const body = topics;
        return new ApiRequest(
            this._sparrowApi.TenantRequest().post('/{tenant}/adminapi/v1/topics/usage', body)
        );
    }

    public getAssociatedAudiences = (tagIds: string[]): ApiRequest => {
        return new ApiRequest(
            this._sparrowApi.TenantRequest()
            .post('/{tenant}/adminapi/v1/tags/audiences', tagIds)
        );
    }

    public getUserTags = (audienceLock: boolean = false, includeDisabled: boolean = false): ApiRequest => {
        return new ApiRequest(
            this._sparrowApi.TenantRequest().get(`{tenant}/adminapi/v1/tags?audienceLocked=${audienceLock}&includeDisabled=${includeDisabled}`)
        );
    }

    public getTagPostCounts = (): ApiRequest => {
        return new ApiRequest(
            this._sparrowApi.TenantRequest().get('{tenant}/api/v1/tags/postCounts')
        );
    }

    public getTagEventCounts = (): ApiRequest => {
        return new ApiRequest(
            this._sparrowApi.TenantRequest().get('{tenant}/api/v1/tags/eventCounts')
        );
    }
}